// extracted by mini-css-extract-plugin
export var avatar = "_ra-3";
export var avatarContainer = "_ra-2";
export var avatarSpacer = "_ra-5";
export var avatarSpacerContainer = "_ra-4";
export var avatarStackContainer = "_ra-1";
export var bubble = "_ra-0";
export var remainderBubble = "_ra-6";